__turbopack_context__.v({
  "dotlist": "featuredProducts-module-scss-module__0q7Dja__dotlist",
  "featuredItems": "featuredProducts-module-scss-module__0q7Dja__featuredItems",
  "featuredItemsLink": "featuredProducts-module-scss-module__0q7Dja__featuredItemsLink",
  "grid": "featuredProducts-module-scss-module__0q7Dja__grid",
  "inner": "featuredProducts-module-scss-module__0q7Dja__inner",
  "item": "featuredProducts-module-scss-module__0q7Dja__item",
  "productBrand": "featuredProducts-module-scss-module__0q7Dja__productBrand",
  "productButton": "featuredProducts-module-scss-module__0q7Dja__productButton",
  "productDetails": "featuredProducts-module-scss-module__0q7Dja__productDetails",
  "productInnerWrapper": "featuredProducts-module-scss-module__0q7Dja__productInnerWrapper",
  "productNotAvailable": "featuredProducts-module-scss-module__0q7Dja__productNotAvailable",
  "productPrice": "featuredProducts-module-scss-module__0q7Dja__productPrice",
  "productSize": "featuredProducts-module-scss-module__0q7Dja__productSize",
  "productTitle": "featuredProducts-module-scss-module__0q7Dja__productTitle",
  "productWrapper": "featuredProducts-module-scss-module__0q7Dja__productWrapper",
  "title": "featuredProducts-module-scss-module__0q7Dja__title",
  "unavailable": "featuredProducts-module-scss-module__0q7Dja__unavailable",
  "wrapper": "featuredProducts-module-scss-module__0q7Dja__wrapper",
});
